import { Button, Link, Paper, styled, TextField, Typography } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: 600,
  boxSizing: 'border-box',
  padding: theme.spacing(3),

  '& h2': {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontSize: '1.125rem',
    color: 'black',
  },

  '& .scar-textField': {
    marginBottom: theme.spacing(2),
  },
}));

export const StyledSubtitle = styled(Typography)(({ theme }) => ({
  color: 'rgba(0, 0, 0, 0.75)',
  marginBottom: theme.spacing(1),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: '0.875rem',
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'block',
  cursor: 'pointer',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));